import { QueryClient } from "@tanstack/react-query";

/**
 * Global QueryClient instance for React Query.
 *
 * @remarks
 * This is the shared QueryClient instance used across the application.
 * Consider using the `useQueryClient()` hook in components instead of importing
 * this directly, as the hook provides better integration with React's lifecycle
 * and ensures you're using the correct client instance from the provider context.
 *
 * @example
 * ```typescript
 * // Preferred approach in components:
 * const queryClient = useQueryClient();
 *
 * // Direct import (use sparingly, mainly for setup, utilities, or non-React contexts):
 * import { queryClient } from './queryClient';
 * ```
 */
export const queryClient = new QueryClient();
